module.exports = __webpack_public_path__ + "media/icons/caret-ca82bc74.svg";